import { render, staticRenderFns } from "./SelectAddTraveller.vue?vue&type=template&id=20b51988"
import script from "./SelectAddTraveller.vue?vue&type=script&lang=js"
export * from "./SelectAddTraveller.vue?vue&type=script&lang=js"
import style0 from "./SelectAddTraveller.vue?vue&type=style&index=0&id=20b51988&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports